<template>
  <div class="container-custom">
    <!-- breadcrumbs -->
    <Breadscrumbs
      :links="[
        { name: 'Support Faq', to: { path: '/support-faq' } },
        { name: 'Create', to: { path: '/support-faq/create' } },
      ]"
    ></Breadscrumbs>

    <!-- page-actions -->
    <div class="page-actions">
      <h2>新增Support FAQ</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block -->
    <SupportFaqCreateEdit></SupportFaqCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import SupportFaqCreateEdit from '@/views/H-2__SupportFaq/c/SupportFaqCreateEdit.vue';

export default {
  components: {
    Breadscrumbs,
    SupportFaqCreateEdit,
  },
  created() {
    this.setFaq({});
  },
  computed: {
    ...mapState('supportFaq', [
      'faq',
    ]),
  },
  methods: {
    ...mapActions('supportFaq', {
      saveFaq: 'save',
      setFaq: 'setFaq',
    }),
    cancelHandler() {
      this.$router.go(-1);
    },
    async saveHandler() {
      this.saveFaq(this.faq).then(() => {
        this.$router.push({ name: 'SupportFaq' });
      });
    },
  },
};
</script>

<style></style>
